




















































import { Vue, Component, Prop, Mixins, Watch } from 'vue-property-decorator';
import { UpdateCount, StudentSchoolClassMovement, UpdateStudentProfilesRequest } from '@/models/student/students-arrange';
import { studentModule } from '@/store/modules/entities/student.module';
import { GPageBase } from '@/mixins';
import { StudentsByClass } from '@/models/student/students-by-class';
import { Student } from '@/models/student/student';
import { GEnum } from '@/constants/enum.defination';
import { DataList } from '@/models/core/data-list';

@Component({
  name: 'GSchoolClassChangeConfirmModal',
  computed: {},
  methods: {},
})
export default class GSchoolClassChangeConfirmModal extends Mixins(GPageBase) {
  moveStudentColumns: any[] = [];
  deleteStudentColumns: any[] = [];
  showConfirmModal: boolean = false;
  currentPage: number = 1;
  pageSize: number = 10;

  @Prop({ default: false }) value: boolean;
  @Prop({ default: 0 }) selectedGrade: number;
  @Prop({ default: (): Student[] => [] }) deleteStudents: Student[];
  @Watch('value')
  openModal(value: boolean) {
    this.showConfirmModal = value;
  }

  mounted() {
    this.moveStudentColumns = [
      {
        title: this.$t('LOGIN_ID').toString(),
        slot: 'studentNumber',
        width: 150,
        align: 'center',
      },
      {
        title: this.$t('FULL_NAME').toString(),
        slot: 'fullName',
        width: 250,
        align: 'center',
      },
      {
        title: this.$t('CLASS_BEFORE_MOVE').toString(),
        slot: 'oldSchoolClassName',
        align: 'center',
      },
      {
        title: this.$t('CLASS_TO_MOVE').toString(),
        slot: 'newSchoolClassName',
        align: 'center',
      },
    ];

    this.deleteStudentColumns = [
      {
        title: this.$t('LOGIN_ID').toString(),
        slot: 'studentNumber',
        width: 150,
        align: 'center',
      },
      {
        title: this.$t('FULL_NAME').toString(),
        slot: 'fullName',
        width: 250,
        align: 'center',
      },
      {
        title: this.$t('SCHOOL_CLASS').toString(),
        slot: 'schoolClassName',
        align: 'center',
      },
    ];
  }

  get studentSchoolClassMovements(): StudentSchoolClassMovement[] {
    return studentModule.studentSchoolClassMovements;
  }

  get studentSchoolClassMovementsByPage(): StudentSchoolClassMovement[] {
    return this.studentSchoolClassMovements.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize);
  }

  handleCancel() {
    this.$emit('input', false);
  }

  handleUpdate() {
    let updateStudentProfiles: UpdateStudentProfilesRequest[] = this.studentSchoolClassMovements.reduce(
      (result: UpdateStudentProfilesRequest[], studentSchoolClassMovement: StudentSchoolClassMovement) => {
        result.push({
          schoolClassID: studentSchoolClassMovement.newSchoolClass.schoolClassID,
          studentID: studentSchoolClassMovement.student.studentID,
          isValid: true,
        } as UpdateStudentProfilesRequest);
        return result;
      },
      []
    );

    this.deleteStudents.forEach((student: Student) => {
      updateStudentProfiles.push({
        schoolClassID: -1,
        studentID: student.studentID,
        isValid: false,
      } as UpdateStudentProfilesRequest);
    });
    studentModule.updateStudentProfiles({ data: updateStudentProfiles } as DataList<UpdateStudentProfilesRequest>).then((result: UpdateCount) => {
      this.$emit('input', false);
      this.showNotice(GEnum.MessageType.Success, this.$t('UPDATE_COMPLETE').toString(), this.$t('MESSAGE_UPDATE_SCHOOL_CLASS', {value: result.count}).toString());

      setTimeout(() => {
        window.location.reload();
      }, 5000);
    });
  }

  handlePagerChange(nextPage: number) {
    this.currentPage = nextPage;
  }

  get studentsBySchoolClasses(): StudentsByClass[] {
    return studentModule.studentsBySchoolClasses;
  }
}
